import React from 'react';

import { useFormContext } from 'react-hook-form';
import { Divider, Switch } from '@mui/material';

import { LbSelect, LbFormControlLabel } from '@infoods/lifebase-ui';
import classes from './FilterSection.module.scss';
import { Flags } from '../../../../../../../utils-types';
import { InbodyType } from '../../../../../../../shared/constants/inbody-info/InbodyType';
import { useScanRangeOptions } from '../../../../../../hooks/useScanRangeOptions/useScanRangeOptions';
import { ScanMetadata } from '../../../../../../interfaces/scanMetadata';
import { InbodyIndicatorsFormValues } from '../../NgzInbodyIndicatorsTab.settings';
import { Option } from '../../../../../../../general-types';

import {
  ComboBox,
  OptionWithDescription,
} from '../../../../../../../shared/components/form-components';

type FilterSectionProps = {
  inbodyTypeFlags: Flags<InbodyType>;
  inbodyTypeOptions: Option[];
  availableScansMetadata: ScanMetadata[];
  showAllScans: boolean;
  onToggleShowAllScans: (checked: boolean) => void;
};

const FilterSection = ({
  inbodyTypeFlags,
  inbodyTypeOptions,
  availableScansMetadata,
  showAllScans,
  onToggleShowAllScans,
}: FilterSectionProps) => {
  const { watch, control } = useFormContext<InbodyIndicatorsFormValues>();

  const { startScanId, endScanId } = watch();

  const { startScanOptions, endScanOptions } = useScanRangeOptions({
    scansMetadata: availableScansMetadata,
    startScanId,
    endScanId,
  });

  const generalInputProps = {
    control,
    className: classes.input,
    variant: 'outlined',
    size: 'small',
  } as const;

  return (
    <>
      {!inbodyTypeFlags.NON_INBODY && (
        <>
          <LbSelect
            {...generalInputProps}
            name="inbodyType"
            label="InBody Machine"
            options={inbodyTypeOptions}
            disabled={showAllScans}
          />
          <Divider orientation="vertical" flexItem />
        </>
      )}
      <ComboBox
        {...generalInputProps}
        name="startScanId"
        label="Start Date"
        options={startScanOptions}
        renderOptionLabel={(option) => (
          <OptionWithDescription label={option.label} description={option.description} />
        )}
        disabled={showAllScans}
        noOptionsText="No Scans Available"
      />
      <ComboBox
        {...generalInputProps}
        name="endScanId"
        label="End Date"
        options={endScanOptions}
        renderOptionLabel={(option) => (
          <OptionWithDescription label={option.label} description={option.description} />
        )}
        disabled={showAllScans}
        noOptionsText="No Scans Available"
      />
      <LbFormControlLabel
        label="All Scans"
        control={
          <Switch
            checked={showAllScans}
            onChange={(_, checked) => onToggleShowAllScans(checked)}
          />
        }
        font="body-14-medium"
      />
    </>
  );
};

export { FilterSection };
